import React from 'react';
export function Footer() {
  return <footer className="bg-mystic-900 border-t border-mystic-800 py-16 px-4 text-center" data-id="element-110">
      <div className="max-w-4xl mx-auto" data-id="element-111">
        <div className="text-3xl font-serif font-bold text-white mb-6" data-id="element-112">
          🔮 ASTRO SER
        </div>

        <p className="text-slate-400 mb-8 max-w-2xl mx-auto" data-id="element-113">
          El sistema de astrología y reprogramación emocional para mujeres que
          quieren dejar de atraer vínculos fríos.
        </p>

        <p className="text-xl font-serif text-gold-400 italic mb-12" data-id="element-114">
          "Porque amar no debería confundirte tanto, vaciarte tanto ni costarte
          tan caro."
        </p>

        <div className="text-sm font-bold text-white mb-6" data-id="element-115">🔮 ASTRO SER™</div>

        <div className="flex flex-wrap justify-center items-center gap-4 text-slate-400 text-sm mb-12" data-id="element-116">
          <span data-id="element-117">📧 contacto@astroser.com</span>
          <span className="hidden sm:inline text-mystic-700" data-id="element-118">|</span>
          <span data-id="element-119">📲 @astroser</span>
          <span className="hidden sm:inline text-mystic-700" data-id="element-120">|</span>
          <span data-id="element-121">🌐 www.astroser.com</span>
        </div>

        <div className="text-xs text-slate-500" data-id="element-122">
          © ASTRO SER™ 2025 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </div>
      </div>
      {/* Extra padding at bottom for sticky CTA */}
      <div className="h-24 md:h-0" data-id="element-123" />
    </footer>;
}